import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export var SCHEDULE_STATUS;
(function (SCHEDULE_STATUS) {
    SCHEDULE_STATUS["APPROVED"] = "40";
    SCHEDULE_STATUS["AWAITING_APPROVAL"] = "25";
    SCHEDULE_STATUS["CANCELED"] = "15";
    SCHEDULE_STATUS["CONFIRMED"] = "35";
    SCHEDULE_STATUS["DONE"] = "10";
    SCHEDULE_STATUS["MISSED"] = "20";
    SCHEDULE_STATUS["NOT_APPROVED"] = "30";
})(SCHEDULE_STATUS || (SCHEDULE_STATUS = {}));
export var WaitingListStatus;
(function (WaitingListStatus) {
    WaitingListStatus["WAITING"] = "A";
    WaitingListStatus["ATTENDED"] = "E";
    WaitingListStatus["CANCELLED"] = "C";
})(WaitingListStatus || (WaitingListStatus = {}));
export var SCHEDULE_OTHER_STATUS;
(function (SCHEDULE_OTHER_STATUS) {
    SCHEDULE_OTHER_STATUS["REQUESTED"] = "R";
    SCHEDULE_OTHER_STATUS["EXECUTION"] = "P";
    SCHEDULE_OTHER_STATUS["CANCELED"] = "X";
})(SCHEDULE_OTHER_STATUS || (SCHEDULE_OTHER_STATUS = {}));
export var SCHEDULE_PREFERRED_TIME;
(function (SCHEDULE_PREFERRED_TIME) {
    SCHEDULE_PREFERRED_TIME["MORNING"] = "M";
    SCHEDULE_PREFERRED_TIME["EVENING"] = "A";
    SCHEDULE_PREFERRED_TIME["NIGHT"] = "E";
})(SCHEDULE_PREFERRED_TIME || (SCHEDULE_PREFERRED_TIME = {}));
export function getPreferredTime(hrAgendamento) {
    switch (hrAgendamento) {
        case SCHEDULE_PREFERRED_TIME.MORNING: return MessageService.translate('patient.preferred_time.morning');
        case SCHEDULE_PREFERRED_TIME.EVENING: return MessageService.translate('patient.preferred_time.evening');
        case SCHEDULE_PREFERRED_TIME.NIGHT: return MessageService.translate('patient.preferred_time.night');
        default: return hrAgendamento;
    }
}
export function getStatusTextByIeStatus(ieStatus) {
    switch (ieStatus) {
        case SCHEDULE_STATUS.APPROVED: return MessageService.translate('patient.approved');
        case SCHEDULE_STATUS.AWAITING_APPROVAL: return MessageService.translate('patient.in-approval');
        case SCHEDULE_STATUS.CANCELED: return MessageService.translate('patient.canceled');
        case SCHEDULE_STATUS.CONFIRMED: return MessageService.translate('patient.confirmed');
        case SCHEDULE_STATUS.DONE: return MessageService.translate('patient.done');
        case SCHEDULE_STATUS.MISSED: return MessageService.translate('patient.missed');
        case SCHEDULE_STATUS.NOT_APPROVED: return MessageService.translate('patient.not.authorized');
        case SCHEDULE_OTHER_STATUS.REQUESTED: return MessageService.translate('patient.requested');
        case SCHEDULE_OTHER_STATUS.EXECUTION: return MessageService.translate('patient.execution');
        case SCHEDULE_OTHER_STATUS.CANCELED: return MessageService.translate('patient.canceled');
        default: return '';
    }
}
export function getStatusTextByIeStatusListaEspera(ieStatus) {
    switch (ieStatus) {
        case WaitingListStatus.ATTENDED: return MessageService.translate('patient.waiting-list.status.attended');
        case WaitingListStatus.CANCELLED: return MessageService.translate('patient.waiting-list.status.cancelled');
        case WaitingListStatus.WAITING: return MessageService.translate('patient.waiting-list.status.waiting');
        default: return '';
    }
}
export function getSubtitle(scheduleType, subTitle) {
    if (scheduleType && (scheduleType == subTitle || !subTitle)) {
        return scheduleType;
    }
    if (scheduleType && subTitle) {
        return `${scheduleType} | ${subTitle}`;
    }
    return '-';
}
//# sourceMappingURL=card-util.js.map